module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-18-e3a94e42813497f091d59de832c1b94a.jpg";